<script>
	import ThresholdWrapper from './ThresholdWrapper.svelte';

	export let device;
</script>

<ThresholdWrapper {device} type={'temperature'} />
